const RELOAD_GUARD_KEY = 'stale-asset-reloaded-at'
// 新しい HTML でも取得に失敗し続ける（CDN の障害など）と、再読み込みを繰り返してしまう。
// 前回の再読み込みから 60 秒以内の失敗では再読み込みしない。
// 再失敗まで 60 秒を超える極端に遅い回線ではこのガードを抜けるが、周期が長いので許容している。
const RELOAD_GUARD_INTERVAL_MS = 60_000

// デプロイで旧ハッシュのチャンクが消えたあとに、開きっぱなしのタブがそれを取りにいくと 404 になる。
// GET の画面遷移はサーバーが Inertia の version 不一致で 409 を返してフルリロードになるが、
// 戻る/進むはサーバーを経由せずに履歴からページを復元するため、この経路では救われない。
// 初回表示でページのチャンクが取れなかった場合も、新しい HTML を取り直せば解決する。
function reloadOnStaleAsset(event: Event): void {
  const reason = (event as Event & { payload?: unknown }).payload

  // 通信断の失敗は、再読み込みしてもブラウザのオフライン画面に置き換わるだけで直らない
  if (navigator.onLine === false) {
    console.warn('オフラインのため、チャンクの取得失敗では再読み込みしません', reason)
    return
  }

  try {
    const now = Date.now()
    const last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY))
    // last が未来なのは端末の時計が巻き戻ったとき。放置すると、そのタブでは再読み込みできなくなる
    if (last <= now && now - last < RELOAD_GUARD_INTERVAL_MS) {
      console.warn('直近に再読み込みしたため、チャンクの取得失敗では再読み込みしません', reason)
      return
    }

    sessionStorage.setItem(RELOAD_GUARD_KEY, String(now))
  } catch (error) {
    // 再読み込みした記録を残せないと繰り返しを止められないので、再読み込みしない
    console.warn('sessionStorage が使えないため、チャンクの取得失敗では再読み込みしません', error, reason)
    return
  }

  console.warn('チャンクの取得に失敗したため、再読み込みします', reason)
  window.location.reload()
}

// Vite は本番ビルドで動的 import（ページのチャンクも含む）の取得に失敗すると、window に
// vite:preloadError を発火する。開発サーバーでは発火しない。
// preventDefault はしない。止めると失敗した import が undefined で解決され、呼び出し側が
// 別の TypeError で落ちるうえ、失敗が隠れる。再読み込みが始まるまでの間は元のエラーが出てよい。
export function installReloadOnPreloadError(): void {
  window.addEventListener('vite:preloadError', reloadOnStaleAsset)
}
